import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";
import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";
import type { EmployeeSchedules } from "@/pages/human-resources/time-management/business/EmployeeSchedules.ts";

export default function useVisibleEmployeesSchedules(): EmployeeSchedules[] {
  const schedulesManager = useSchedulesManager();
  const {
    state: { filteredOutEntities },
  } = useScheduleViewFilters();
  return schedulesManager
    .listSchedules()
    .filter((es) => filteredOutEntities.shouldShowEmployeeSchedules(es));
}
